import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { MyDatePickerModule } from 'mydatepicker';
import { CovanceFileUploadComponent } from './covance-file-upload.component';
import { UploadedFileErrorsComponent } from './uploaded-file-errors.component';

@NgModule({
    declarations: [CovanceFileUploadComponent, UploadedFileErrorsComponent],
    imports: [SharedModule, MyDatePickerModule],
    exports: [CovanceFileUploadComponent]
})
export class CovanceFileUploadModule { }